import ObjectCache from './CacheService';
import LogicBaseConversationApi from '../server/LogicBaseConversationApi';
import UserAccount from '../UserAccount';
import LogicBaseConversation from '../../models/logicbaseconversation';

class LogicBaseConversationCache extends ObjectCache {
  api = LogicBaseConversationApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseConversation(results._id, results.ct, results.ut, results.k, results.p, results.rt);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseConversationCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
